// extracted by mini-css-extract-plugin
export default {"questions-cont":"QuestionNode_questions-cont__6W36C","question":"QuestionNode_question__XaOuG","svg":"QuestionNode_svg__YIL3v","placeholder":"QuestionNode_placeholder__0Su5O"};